import { Book } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import axios from '../../../axios'
import assets from "../../../assets/assets";
import PdfQType from "./PdfQType";

function PublishedQListPreRead({ publishPre_id, setIsPopupOpen }) {
    const [isGettingData, setIsGettingData] = useState(false);
    const userId = useSelector((state) => state.user?.currentUser?.id);
    const [homeMain, setHomeMain] = useState({
        preReadData: null,
    });

    useEffect(() => {
        const pendingBox = async () => {
            setIsGettingData(true)
            try {
                let response = await axios.get(`homework/preRead/getById/${publishPre_id}`);

                response &&
                    setHomeMain((prev) => ({ ...prev, preReadData: response.data.data }));
                setIsGettingData(false);
            } catch (error) {
                console.log(error);
                setIsGettingData(false);
            }
        };
        pendingBox();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            className="position-fixed top-0 start-0 w-full h-full d-flex justify-content-center align-items-center"
            style={{
                backgroundColor: "rgba(0,0,0,0.4)",
                zIndex: 9999,
            }}
        >
            <div
                className="bg-white rounded shadow relative"
                style={{
                    width: "90%",
                    maxWidth: "700px",
                    maxHeight: "500px",
                    minHeight: "425px",
                    overflowY: "auto",
                    backgroundColor: "#FFF6EF",
                }}
            >
                <img src={assets.CrossIcon} onClick={() => setIsPopupOpen(false)} className="w-7 cursor-pointer absolute top-1 right-1" alt="crossicon" />
                {!isGettingData ? (
                    <>
                        {/* Header */}
                        <div
                            className="p-4"
                            style={{ backgroundColor: "#fdefe4", height: "120px" }}
                        >
                            <div className="d-flex justify-content-between align-items-center mb-3 ">
                                <div className="d-flex align-items-center gap-2">
                                    <Book size={20} />
                                    <h5 className="fw-bold m-0">{homeMain?.preReadData?.name}</h5>
                                </div>
                            </div>

                            {/* Subject + Status + Members */}
                            <div className="d-flex align-items-center mb-3 gap-2 flex-wrap">
                                <span className="badge bg-light text-dark d-flex align-items-center">
                                    📘 {homeMain?.preReadData?.subject_id?.name}
                                </span>
                                <span className="badge bg-warning text-white">Published</span>
                            </div>
                        </div>

                        <div className="p-4" style={{ backgroundColor: "#f3f3f3", minHeight: "300px" }}>
                            {/* Description */}
                            <p
                                className="text-muted"
                                style={{ fontSize: "0.95rem", wordBreak: "break-all" }}
                            >
                                {homeMain?.preReadData?.description}
                            </p>

                            <hr />

                            {/* Attachments */}
                            {homeMain?.preReadData?.attachments?.length > 0 ? (
                                <div className="col-12">
                                    <h6 className="fw-semibold mt-4 mb-2">📎 Shared Files</h6>
                                    <div className="row">
                                        {homeMain?.preReadData?.attachments.map((attachment, idx) => (
                                            <div className="col-12 col-sm-6 col-md-4 mb-3 " key={idx}>
                                                <PdfQType
                                                    attachData={homeMain?.preReadData}
                                                    attachment={attachment}
                                                />
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ) : (<div className="p-1">No Attachment!!</div>)
                            }
                        </div>
                    </>
                ) : homeMain?.preReadData === null ? (<div className="p-2">No Pre-read Found!!</div>) : (
                    <img className="w-40 m-auto" src="/gif/LoaderDot.gif" alt="" />
                )}
            </div>
        </div>
    )
}

export default PublishedQListPreRead;
